export const TOGGLE_NAVIGATION_MENU = 'TOGGLE_NAVIGATION_MENU'
export const OPEN_NAVIGATION_MENU = 'OPEN_NAVIGATION_MENU'

export const toggleNavigationMenu = () => ({
  type: TOGGLE_NAVIGATION_MENU
})
export const openNavigationMenu = () => ({
  type: OPEN_NAVIGATION_MENU
})
